import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";

import { getButtonBgColor, getFontFamily } from "slices";

const DayShow = ({ focusedDate, focusedStartDate, focusedEndDate, onClickDate }) => {
  const color = useSelector(getButtonBgColor);
  const fontFamily = useSelector(getFontFamily);

  const generateCalendar = (month, year) => {
    const daysInMonth = moment(`${year}-${month}`, "YYYY-M").daysInMonth();
    const firstDayOfWeek = moment(`${year}-${month}-01`, "YYYY-M-D").day();

    const dates = Array.from({ length: daysInMonth }, (_, i) => moment(`${year}-${month}-${i + 1}`, "YYYY-M-D"));

    for (let i = 0; i < firstDayOfWeek; i++) {
      dates.unshift(null);
    }

    const lastDayOfWeek = dates[dates.length - 1].day();

    for (let i = lastDayOfWeek; i < 6; i++) {
      dates.push(null);
    }

    return dates;
  };

  const calendar = generateCalendar(focusedDate.month() + 1, focusedDate.year());

  return (
    <>
      {/* Days of the week */}
      {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day, index) => (
        <div
          key={index}
          className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50"
        >
          {day}
        </div>
      ))}

      {calendar.map((date, i) => {
        if (date) {
          const isStart = date.isSame(focusedStartDate, "day");
          const isEnd = date.isSame(focusedEndDate, "day");
          const isWithinRange = date.isBetween(focusedStartDate, focusedEndDate, null, "[]"); // "[]" includes start and end dates

          return (
            <Button
              key={i}
              className={`hayley-custom hayley-flex hayley-h-9 hayley-min-h-fit hayley-w-9 hayley-min-w-fit hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-rounded-none hayley-border hayley-border-solid hayley-border-transparent hayley-font-opensans hayley-text-sm hayley-text-secondary disabled:hayley-text-custom-4 ${
                isStart ? `hayley-text-white` : isEnd ? `hayley-text-white` : isWithinRange ? " hayley-text-black" : "hayley-bg-white"
              }`}
              sx={{
                "&.hayley-custom": {
                  fontFamily: `${fontFamily} !important`,
                  "&:hover": { borderColor: `${color} !important` },
                },
                backgroundColor: isStart || isEnd ? `${color} !important` : isWithinRange ? `${color + "40"} !important` : "#fff",
              }}
              onClick={() => onClickDate(date)}
              disabled={date.isBefore(moment().subtract(1, "day"))}
            >
              {date.date()}
            </Button>
          );
        }

        return (
          <div
            key={i}
            className="hayley-flex hayley-h-9 hayley-w-9 hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-border-none hayley-bg-white hayley-font-opensans"
          />
        );
      })}
    </>
  );
};

export default DayShow;
